import {
  List,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
} from '@mui/material';
import { PopupState, bindPopover } from 'material-ui-popup-state/hooks';
import { CPConfirm } from 'src/components/base/CPConfirm/CPConfirm';
import { Iconify } from 'src/components/iconify';
import { useLocales } from 'src/locales';

export const ConversationAiItemOptions = ({
  state,
  onDelete,
  onEdit,
}: {
  state: PopupState;
  onDelete(): void;
  onEdit(): void;
}) => {
  const { translate } = useLocales();

  return (
    <Popover
      {...bindPopover(state)}
      onClick={(event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
      }}
      onClose={() => {
        state.close();
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{ '& .MuiPaper-root': { marginTop: 0 } }}
    >
      <List>
        <MenuItem
          onClick={() => {
            onEdit();
            state.close();
          }}
        >
          <ListItemIcon>
            <Iconify icon="tabler:edit" />
          </ListItemIcon>

          <ListItemText primary={translate('shared.buttons.edit')} />
        </MenuItem>

        <CPConfirm
          onConfirm={() => {
            onDelete();
            state.close();
          }}
        >
          <MenuItem sx={{ color: 'error.main' }}>
            <ListItemIcon>
              <Iconify icon="tabler:trash" />
            </ListItemIcon>

            <ListItemText primary={translate('shared.buttons.delete')} />
          </MenuItem>
        </CPConfirm>
      </List>
    </Popover>
  );
};
